export default "__VITE_ASSET__C_7UTQpa__"